import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import { disableBackButton } from '../../ConstantComponents/Constants'
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Avatar, Card, CardContent, CardHeader, Chip, Divider, Grid, MenuItem, Modal, TextField, Tooltip, Backdrop } from '@mui/material';
import axios from 'axios';
import '../../../customcss/loadernew.css'
import ASTChartComponent from './ASTChartComponent';
import config from '../../../config.json'

const BASE_URL = config.SERVER_URL

export default function ASTMarket() {

    disableBackButton()

    const drawerWidth = 300;

    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    // jwt working//


    const navigate = useNavigate()
    const t1 = sessionStorage.getItem("sessionid")

    //////console.log("token from redux at enter strain page", t1)

    var decodet1 = ""

    try {
        decodet1 = jwtDecode(t1)
    } catch (error) {

    }

    ////////////////////// ast variables ////////////////////

    const [backdropopen, setbackdropopen] = useState(true)
    const [salmonellaanti, setsalmonellaanti] = useState([])
    const [salmonelladisplay, setsalmonelladisplay] = useState('block')

    const [shigellaanti, setshigellaanti] = useState([])
    const [shigelladisplay, setshigelladisplay] = useState('block')

    const [campyloanti, setcampyloanti] = useState([])
    const [campylodisplay, setcampylodisplay] = useState('black')

    const [vibriochanti, setvibriochanti] = useState([])
    const [vibriocdisplay, setvibriocdisplay] = useState('block')

    const [vibriopaanti, setvibriopaanti] = useState([])
    const [vibriopdisplay, setvibriopdisplay] = useState('block')

    const [listeriaanti, setlisteriaanti] = useState([])
    const [listeriadisplay, setlisteriadisplay] = useState('block')

    const [bacillusanti, setbacillusanti] = useState([])
    const [bacillusdisplay, setbacillusdisplay] = useState('block')

    const [staphanti, setstaphanti] = useState([])
    const [staphdisplay, setstaphdisplay] = useState('block')

    const [yersiniaanti, setyersiniaanti] = useState([])
    const [yersiniadisplay, setyersiniadisplay] = useState('block')

    const [daecanti, setdaecanti] = useState([])
    const [daecdisplay, setdaecdisplay] = useState('block')

    const [etecanti, setetecanti] = useState([])
    const [etecdisplay, setetecdisplay] = useState('block')

    const [epecanti, setepecanti] = useState([])
    const [epecdisplay, setepecdisplay] = useState('block')

    const [ehecanti, setehecanti] = useState([])
    const [ehecdisplay, setehecdisplay] = useState('block')

    const [eiecanti, seteiecanti] = useState([])
    const [eiecdisplay, seteiecdisplay] = useState('block')


    const [statemaster, setstatemaster] = useState([])

    const [state, setstate] = useState(0)

    const inputlabelprops = {
        style: { color: '#45a2fa', fontSize: '17px' }
    }



    useEffect(() => {
        // if (decodet1 === "") {
        //     navigate("/")
        // } else {

        //     getPrerequisits(state)
        // }
        getPrerequisits(state)
    }, [state])





    function getPrerequisits(state) {

        setbackdropopen(true)



        const params = new URLSearchParams();

        params.append("state", state)

        const getAST = axios.post(BASE_URL + '/dashboard/getASTMarket', params, { withCredentials: true })
        const getState = axios.post(BASE_URL + '/master/getStatesnew', {}, { withCredentials: true })


        Promise.all([getAST, getState])
            .then(function (responses) {

                setbackdropopen(true)

                setsalmonellaanti(responses[0].data.Salmonella)
                if (responses[0].data.Salmonella.length == 0) {
                    setsalmonelladisplay('none')
                }

                setshigellaanti(responses[0].data.Shigella)
                if (responses[0].data.Shigella.length == 0) {
                    setshigelladisplay('none')
                }

                setcampyloanti(responses[0].data.Campylobacter)
                if (responses[0].data.Campylobacter.length == 0) {
                    setcampylodisplay('none')
                }

                setvibriochanti(responses[0].data.VibrioCh)
                if (responses[0].data.VibrioCh.length == 0) {
                    setvibriocdisplay('none')
                }

                setvibriopaanti(responses[0].data.VibrioPa)
                if (responses[0].data.VibrioPa.length == 0) {
                    setvibriopdisplay('none')
                }

                setlisteriaanti(responses[0].data.Listeria)
                if (responses[0].data.Listeria.length == 0) {
                    setlisteriadisplay('none')
                }

                setbacillusanti(responses[0].data.Bacillus)
                if (responses[0].data.Bacillus.length == 0) {
                    setbacillusdisplay('none')
                }

                setstaphanti(responses[0].data.Staph)
                if (responses[0].data.Staph.length == 0) {
                    setstaphdisplay('none')
                }

                setyersiniaanti(responses[0].data.Yersinia)
                if (responses[0].data.Yersinia.length == 0) {
                    setyersiniadisplay('none')
                }

                setdaecanti(responses[0].data.DAEC)
                if (responses[0].data.DAEC.length == 0) {
                    setdaecdisplay('none')
                }

                setetecanti(responses[0].data.ETEC)
                if (responses[0].data.ETEC.length == 0) {
                    setetecdisplay('none')
                }

                setepecanti(responses[0].data.EPEC)
                if (responses[0].data.EPEC.length == 0) {
                    setepecdisplay('none')
                }

                setehecanti(responses[0].data.EHEC)
                if (responses[0].data.EHEC.length == 0) {
                    setehecdisplay('none')
                }

                seteiecanti(responses[0].data.EIEC)
                if (responses[0].data.EIEC.length == 0) {
                    seteiecdisplay('none')
                }

                setstatemaster(responses[1].data.States)

                setbackdropopen(false)


            }).catch(function (errors) {

            });

    }

    /*
        Salmonella enterica
    */

    const antinames = salmonellaanti.map(item => item.testSubcategoryName)
    const salsensitive = salmonellaanti.map(item => item.sensitivePercentage)
    const salintermediate = salmonellaanti.map(item => item.intermediatePercentage)
    const salresistant = salmonellaanti.map(item => item.resistantPercentage)

    /*
        Shigella spp.
    */
    const antinamesshi = shigellaanti.map(item => item.testSubcategoryName)
    const shisensitive = shigellaanti.map(item => item.sensitivePercentage)
    const shiintermediate = shigellaanti.map(item => item.intermediatePercentage)
    const shiresistant = shigellaanti.map(item => item.resistantPercentage)

    /*
        Campylobacter spp.
    */

    const antinamescamp = campyloanti.map(item => item.testSubcategoryName)
    const campsensitive = campyloanti.map(item => item.sensitivePercentage)
    const campintermediate = campyloanti.map(item => item.intermediatePercentage)
    const campresistant = campyloanti.map(item => item.resistantPercentage)

    /*
        Vibrio cholerae
    */

    const antinamescvic = vibriochanti.map(item => item.testSubcategoryName)
    const vicsensitive = vibriochanti.map(item => item.sensitivePercentage)
    const vicintermediate = vibriochanti.map(item => item.intermediatePercentage)
    const vicresistant = vibriochanti.map(item => item.resistantPercentage)

    /*
        Vibrio parahaemolyticus 
    */

    const antinamescvip = vibriopaanti.map(item => item.testSubcategoryName)
    const vipsensitive = vibriopaanti.map(item => item.sensitivePercentage)
    const vipintermediate = vibriopaanti.map(item => item.intermediatePercentage)
    const vipresistant = vibriopaanti.map(item => item.resistantPercentage)

    /**
     * Listeria monocytogenes
     */

    const antinamesclis = listeriaanti.map(item => item.testSubcategoryName)
    const lissensitive = listeriaanti.map(item => item.sensitivePercentage)
    const lisintermediate = listeriaanti.map(item => item.intermediatePercentage)
    const lisresistant = listeriaanti.map(item => item.resistantPercentage)

    /**
     * Bacillus cereus
     */
    const antinamescbac = bacillusanti.map(item => item.testSubcategoryName)
    const bacsensitive = bacillusanti.map(item => item.sensitivePercentage)
    const bacintermediate = bacillusanti.map(item => item.intermediatePercentage)
    const bacresistant = bacillusanti.map(item => item.resistantPercentage)

    /**
     * Staphylococcus aureus
     */

    const antinamescstaph = staphanti.map(item => item.testSubcategoryName)
    const staphsensitive = staphanti.map(item => item.sensitivePercentage)
    const staphintermediate = staphanti.map(item => item.intermediatePercentage)
    const staphresistant = staphanti.map(item => item.resistantPercentage)

    /**
     * Yersinia enterocolitica
     */

    const antinamescyer = yersiniaanti.map(item => item.testSubcategoryName)
    const yersensitive = yersiniaanti.map(item => item.sensitivePercentage)
    const yerintermediate = yersiniaanti.map(item => item.intermediatePercentage)
    const yerresistant = yersiniaanti.map(item => item.resistantPercentage)

    /**
     * DAEC
     */

    const antinamescdaec = daecanti.map(item => item.testSubcategoryName)
    const daecsensitive = daecanti.map(item => item.sensitivePercentage)
    const daecintermediate = daecanti.map(item => item.intermediatePercentage)
    const daecresistant = daecanti.map(item => item.resistantPercentage)

    /**
     * ETEC
     */

    const antinamesetec = etecanti.map(item => item.testSubcategoryName)
    const etecsensitive = etecanti.map(item => item.sensitivePercentage)
    const etecintermediate = etecanti.map(item => item.intermediatePercentage)
    const etecresistant = etecanti.map(item => item.resistantPercentage)

    /**
     * EPEC
     */

    const antinamesepec = epecanti.map(item => item.testSubcategoryName)
    const epecsensitive = epecanti.map(item => item.sensitivePercentage)
    const epecintermediate = epecanti.map(item => item.intermediatePercentage)
    const epecresistant = epecanti.map(item => item.resistantPercentage)

    /**
     * EHEC
     */

    const antinamesehec = ehecanti.map(item => item.testSubcategoryName)
    const ehecsensitive = ehecanti.map(item => item.sensitivePercentage)
    const ehecintermediate = ehecanti.map(item => item.intermediatePercentage)
    const ehecresistant = ehecanti.map(item => item.resistantPercentage)

    /**
     * EHEC
     */

    const antinameseiec = eiecanti.map(item => item.testSubcategoryName)
    const eiecsensitive = eiecanti.map(item => item.sensitivePercentage)
    const eiecintermediate = eiecanti.map(item => item.intermediatePercentage)
    const eiecresistant = eiecanti.map(item => item.resistantPercentage)



    return (
        <>
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                    backgroundColor: '#f3f4f7'
                }}>
                <Sidebar />
                <div style={{ marginTop: '100px', marginLeft: "15px", backgroundColor: '#f3f4f7' }}>

                    <Box component="main" sx={{ p: 1, backgroundColor: '#f3f4f7', height: '100%' }}>

                        <div style={{ marginBottom: '100px'}}>
                            <h3 className="rubik-font" style={{ fontWeight: 500, fontFamily: 'Rubik, sans-serif', color: 'black', marginLeft: "15px", marginBottom: '35px' }}>Antibiotic Susceptibility Pattern for Enteric Pathogens in Market Surveillance</h3>

                            <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 1 }} style={{ display: 'flex', justifyContent: "flex-start" }} >
                                <Grid item xs={12} md={6} lg={4}>
                                    <div>
                                        <TextField

                                            required
                                            fullWidth
                                            id="outlined-select-district"
                                            select
                                            label="Select State"
                                            value={state}
                                            onChange={
                                                (e) => setstate(e.target.value)
                                                //setdistrict(centers.filter(op => op.center_dist_id === district))
                                            }
                                            InputLabelProps={inputlabelprops}
                                            sx={{ backgroundColor: 'white'}}


                                        // InputProps={{
                                        //   readOnly: true,
                                        // }}
                                        //onChange={handleChange}
                                        >
                                            {statemaster.map((option) => (
                                                <MenuItem key={option.stateId} value={option.stateId}>
                                                    {option.stateName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                </Grid>
                            </Grid>


                            <Grid container spacing={1} sx={{ paddingLeft: 2, paddingRight: 1 }} style={{ display: salmonelladisplay }} >
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Salmonella enterica'} antibioticnames={antinames} sensitivevals={salsensitive} intermediatevals={salintermediate} resistantvals={salresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: daecdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={'(DAEC)'} pathname={'Diarrhoeagenic Escherichia coli'} antibioticnames={antinamescdaec} sensitivevals={daecsensitive} intermediatevals={daecintermediate} resistantvals={daecresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: etecdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={'(ETEC)'} pathname={'Diarrhoeagenic Escherichia coli'} antibioticnames={antinamesetec} sensitivevals={etecsensitive} intermediatevals={etecintermediate} resistantvals={etecresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: epecdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={'(EPEC)'} pathname={'Diarrhoeagenic Escherichia coli'} antibioticnames={antinamesepec} sensitivevals={epecsensitive} intermediatevals={epecintermediate} resistantvals={epecresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: ehecdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={'(EHEC)'} pathname={'Diarrhoeagenic Escherichia coli'} antibioticnames={antinamesehec} sensitivevals={ehecsensitive} intermediatevals={ehecintermediate} resistantvals={ehecresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: eiecdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={'(EIEC)'} pathname={'Diarrhoeagenic Escherichia coli'} antibioticnames={antinameseiec} sensitivevals={eiecsensitive} intermediatevals={eiecintermediate} resistantvals={eiecresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: shigelladisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Shigella spp.'} antibioticnames={antinamesshi} sensitivevals={shisensitive} intermediatevals={shiintermediate} resistantvals={shiresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: campylodisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Campylobacter spp.'} antibioticnames={antinamescamp} sensitivevals={campsensitive} intermediatevals={campintermediate} resistantvals={campresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: vibriocdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Vibrio cholerae'} antibioticnames={antinamescvic} sensitivevals={vicsensitive} intermediatevals={vicintermediate} resistantvals={vicresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: vibriopdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Vibrio parahaemolyticus'} antibioticnames={antinamescvip} sensitivevals={vipsensitive} intermediatevals={vipintermediate} resistantvals={vipresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: listeriadisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Listeria monocytogenes'} antibioticnames={antinamesclis} sensitivevals={lissensitive} intermediatevals={lisintermediate} resistantvals={lisresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: bacillusdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Bacillus cereus'} antibioticnames={antinamescbac} sensitivevals={bacsensitive} intermediatevals={bacintermediate} resistantvals={bacresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: staphdisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Staphylococcus aureus'} antibioticnames={antinamescstaph} sensitivevals={staphsensitive} intermediatevals={staphintermediate} resistantvals={staphresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} sx={{ marginTop: '5px', paddingLeft: 2, paddingRight: 1 }} style={{ display: yersiniadisplay }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <div className="linechart" style={{ backgroundColor: '#ffffff', borderRadius: '10px', padding: '20px', width: '100%', marginTop: '50px' }} >
                                        <ASTChartComponent sec={''} pathname={'Yersinia enterocolitica'} antibioticnames={antinamescyer} sensitivevals={yersensitive} intermediatevals={yerintermediate} resistantvals={yerresistant} ></ASTChartComponent>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                </div>
            </Box>
            <Backdrop
                sx={{ color: "#000000", zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: 'rgba(255,255,255,0.9)' }}
                open={backdropopen}
            >
                {/* <CircularProgress color="inherit" /> */}

                <div className="boxes">
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="box">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </Backdrop>
        </>
    )
}
